import FrameConfig from "@lib/classes/FrameConfig";
import { createIntl } from "react-intl";

export const localeMap = {
  zh: "zh",
  en: "en",
  ja: "ja",
};

export function formatCurrency(
  amount: number | bigint,
  currency: string = global?.currency || global?.window?.currency,
): string {
  const intl = createIntl({ locale: localeMap[new FrameConfig().language || "en"] });
  const options = { style: "currency", currency: currency };
  return intl.formatNumber(amount, options);
}

// export function formatDecimal(number: number | bigint, options = {}): string {
//   const intl = createIntl({ locale: options.locale || window.locale });
//   return intl.formatNumber(number, options);
// }
